import type { StripeConstructorOptions } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

export async function stripeLoadingProvider(useConnectedAccount: boolean) {
    const publishableKey = window.stripeSetup.publishableKey;
    const options: StripeConstructorOptions = { locale: 'en' };

    if (useConnectedAccount && window.stripeSetup.connectedAccount) {
        options.stripeAccount = window.stripeSetup.connectedAccount;
    }

    try {
        if (window.Stripe) {
            return window.Stripe(publishableKey, options);
        }

        return await loadStripe(publishableKey, options);
    } catch (e) {
        console.warn('Ignoring loadStripe errors', e);
        return null;
    }
}
